var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    rx: 10,
    fill: "#EFF0F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.35 42.75H48.85C44.05 42.75 40 46.8 40 51.65V78.35C40 83.2 44.05 87.25 48.9 87.25H81.15C85.95 87.25 90.05 83.2 90.05 78.35V51.65C90.25 46.8 86.2 42.75 81.35 42.75V42.75ZM84.9 78.6C84.9 80.65 83.4 82.4 81.35 82.4H48.85C46.8 82.4 45.05 80.6 45.05 78.6V51.65C45.05 49.6 46.85 47.85 48.85 47.85H81.1C83.15 47.85 84.9 49.65 84.9 51.65V78.6Z",
    fill: "#D6DBDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 51.3984C75.8 51.3984 74.75 51.8984 74 52.6484C73.25 53.3984 73 54.1984 73 55.1984C73 57.2484 74.8 58.9984 76.8 58.9984C78.8 58.9984 80.6 57.1984 80.6 55.1984C80.6 53.1984 78.8 51.3984 76.8 51.3984V51.3984Z",
    fill: "#D6DBDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7504 61.8032C73.0004 60.0032 70.4504 59.7532 69.2004 61.3032L65.9004 66.1532C64.9004 67.7032 62.6004 67.7032 61.6004 66.1532L60.6004 64.9032C59.6004 63.3532 57.3004 63.6532 56.3004 65.1532L50.6504 74.0532C49.6504 75.8532 50.6504 78.1032 52.9504 78.1032H76.8004C78.6004 78.1032 79.8504 76.0532 79.1004 74.3032L73.7504 61.8032Z",
    fill: "#D6DBDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.83856581943d0f488c23c43ed035c95d.svg";
export { ForwardRef as ReactComponent };